module.exports = __webpack_public_path__ + "assets/981b0235ffcbcd75fb40db71d9e93886.mp3";